import ScrollModal from "@/components/common/scroll-modal";
import { Heading, Button } from "@elaniintc/goes-design-system";

interface DeleteTemplateModalProps {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
  isLoading?: boolean;
}

export default function DeleteTemplateModal({
  open,
  onClose,
  onDelete,
  isLoading = false,
}: DeleteTemplateModalProps) {
  return (
    <ScrollModal
      isOpen={open}
      onClose={onClose}
      title="Desactivar plantilla"
      description="¿Estás seguro de que deseas desactivar la plantilla? Se ocultará de la vista principal y no podrás usar sus datos."
      srOnlyDescription={false}
      modalContentClassName="w-full max-w-[520px] max-h-[680px] flex flex-col p-6 pt-0"
    >
      <div className="flex py-8 justify-center flex-col items-center">
        <Heading variant="h2" className="!mb-0">
          Desactivar plantilla
        </Heading>
        <p className="text-center text-body font-normal leading-3xl">
          ¿Estás seguro de que deseas desactivar la plantilla? Se ocultará de la
          vista principal y no podrás usar sus datos.
        </p>
      </div>
      <div className="w-full grid grid-cols-1 tablet:grid-cols-2 py-3 gap-3">
        <Button
          variant="tertiary"
          size="lg"
          type="button"
          disabled={false}
          onClick={onClose}
          className="min-w-[120px] cursor-pointer"
        >
          Cancelar
        </Button>
        <Button
          variant="danger-primary"
          size="lg"
          type="submit"
          disabled={false}
          className="min-w-[140px] cursor-pointer disabled:bg-neutral-object-accent disabled:text-on-disabled disabled:border-none disabled:shadow-none"
          onClick={onDelete}
          isLoading={isLoading}
        >
          Desactivar
        </Button>
      </div>
    </ScrollModal>
  );
}
